<template>
  <div class="menu" role="navigation" :aria-label="t('mainNav')">
    <el-tooltip
      v-for="(item, index) in routerData"
      :key="index"
      :content="menuTitle(item)"
      placement="right"
      :show-after="400"
      :disabled="!isOverflow(menuTitle(item))"
    >
      <div
        class="men_box"
        :class="isSidebarMenuActive(item, $route.path) ? 'active' : ''"
        @click="handleOpen(item, item.path, index)"
      >
        <el-icon class="iceoc">
          <component :is="item.icon || 'Menu'" />
        </el-icon>
        <span class="men_box__label">{{ menuTitle(item) }}</span>
      </div>
    </el-tooltip>
  </div>
</template>

<script setup>
import {
  reactive,
  defineExpose,
  defineEmits,
  computed,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "@/stores/modules/router.js";
const userData = useStore();
const { getAcitve } = userData;

const router = useRouter();
const route = useRoute();
const emit = defineEmits(["childer"]);

import { getLoginUser } from "@/utils/loginUser";
import { getPortalForCurrentRoute, PORTAL_PLATFORM } from "@/utils/authSession";
import { getMenuRoutesForPortal, resolveMenuItemPath } from "@/router/portalRoutes.js";
import { filterRoutesByMenuPermissions, getLoginUserMenuPermissions, isSuperAdminRole } from "@/utils/adminMenuPermission.js";
import { isSidebarMenuActive } from "@/utils/pageTitle.js";
import { t } from "@/locale/index.js";
import { menuTitle } from "@/utils/menuI18n.js";
const state = reactive({
  isCollapse: false,
});

const handleOpen = (key, keyPath, index) => {
  const targetPath = resolveMenuItemPath(key);
  router.push(targetPath);
  emit("childer", { ...key, path: targetPath });
  state.isActive = index;
  getAcitve(index);
};

const isOverflow = (title) => (title || '').length > 5;

const toggleCollapse = () => (state.isCollapse = !state.isCollapse);

defineExpose({
  toggleCollapse,
});

const filterRouterByRole = (routes, roleId, isPlatform) => {
  if (isPlatform) {
    return routes
  }
  if (Number(roleId) === 2) {
    return routes.filter((item) => item.permission === 'captain')
  }
  return routes.filter((item) => item.permission !== 'platform' && (item.permission !== 'captain' || item.path === '/attendance/annualLeave'))
}

const routerData = computed(() => {
  const user = getLoginUser()
  const portal = getPortalForCurrentRoute()
  const isPlatform = portal === PORTAL_PLATFORM
  const roleId = Number(user?.roleId ?? user?.role_id ?? 0)
  const routes = filterRouterByRole(
    getMenuRoutesForPortal(portal),
    roleId,
    isPlatform,
  ).filter(i => i.show !== false)
  const permissions = isSuperAdminRole(roleId) ? null : getLoginUserMenuPermissions(user)
  return filterRoutesByMenuPermissions(routes, permissions)
});
</script>

<style>
.menu {
  width: 180px;
  height: calc(100vh - 100px);
  overflow: auto;
  background-color: var(--admin-sidebar-bg, #0a152e);
}

.item_contnt {
  padding: 0 30px 0 20px;
  margin-bottom: 20px;
}

.el-menu {
  background-color: var(--admin-sidebar-bg, #0a152e) !important;
  border: none !important;
}

.el-menu-item,
.el-sub-menu__title {
  margin-bottom: 2%;
  height: 35px !important;
  color: #fff !important;
}

.el-menu-item:hover {
  background-color: var(--admin-sidebar-active, #1e6aed) !important;
  border-radius: 2px !important;
}

.el-sub-menu__title:hover {
  background-color: #1d273e !important;
}

.men_box {
  color: #fff;
  width: calc(100% - 24px);
  margin: 0 12px 20px;
  padding: 8px 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-radius: var(--admin-radius-sm, 6px);
  font-size: 15px;
  min-height: 36px;
  box-sizing: border-box;
  gap: 8px;
}

.men_box:last-child {
  margin-bottom: 0;
}

.men_box__label {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.3;
}

.active {
  background-color: var(--admin-sidebar-active, #1e6aed) !important;
}

.el-icon {
  font-size: 18px !important;
}

.iceoc {
  font-size: 16px;
  flex-shrink: 0;
}

.men_box:hover {
  background-color: var(--admin-sidebar-active, #1e6aed);
}

::-webkit-scrollbar {
  width: 2px;
  height: 2px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: transparent;
}
</style>
